import React from 'react';
import { Navigate } from 'react-router-dom';
import BankAccounts from '../../bank-accounts/bank-accounts';
import { useFinanceSection } from '../section/finance-section-context';

// Two different companies, two different answers, and only one of them has a
// page here any more.
//
// On Connect, the bank account is not a screen of its own: Stripe's `payouts`
// component owns the destination account, the payout schedule and the payout
// history together, in one frame, and that component now lives on Payouts
// (payouts.js). Two sub-menu entries mounting the identical component is one
// screen pretending to be two, so this route sends a Connect company next
// door rather than drawing it again. The entry itself is gated out of the
// sidebar for those companies (layout.js's `legacyBank` flag) — this redirect
// is for the links that already exist: bookmarks, and the Settings -> Payments
// route in router.js that has been pointing here since the Finance move.
//
// A legacy company keeps exactly what it had. It has no Stripe account, no
// Stripe component to show, and a real bank on file with us — BankAccounts
// renders its own PageHeader ("Payments"), so nothing is added around it.
const BankAccount = () => {
  const { model, status } = useFinanceSection();
  const onStripe = model === 'CONNECT_DIRECT'
    && !!status?.hasAccount
    && status?.connectStatus === 'READY';

  if (onStripe) return <Navigate to="/dashboard/finance/payouts" replace />;

  return <BankAccounts />;
};

export default BankAccount;
